import {
  Component,
  OnInit,
  NgZone
} from '@angular/core';
import { MainPageService } from './../../../main-page.service';
import { Subject } from 'rxjs';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { PipeGroupModel } from '../../../../models/dictionaries/pipe-group.model';
import { UnitsConverter } from '../../../../shared/units-converter/units-converter';
import { PipeSizeModel } from '../../../../models/parts/pipe-size.model';
import { PipeMaterialGroupModel } from '../../../../models/dictionaries/pipe-material-group.model';

@Component({
  selector: 'app-pipes-managment',
  template: `<div *ngIf="pipeData !== undefined && pipeData !== null">
    <div class="row" style="padding-left: 12px;">
        <b>Pipe:</b> &nbsp;{{pipeData.name}}</div>
    <button type="button" class="btn btn-danger red-button" (click)="returnHandler()">Return</button>
    <button type="submit" class="btn btn-primary save-button" [disabled]="ctrl.invalid || ctrl2.invalid || ctrl3.invalid" (click)="save()">Save</button>
    <div class="row">

        <div class="col-6" style="line-height: 30px; padding-top: 30px;">
            <div class="display-flex">
                <div class="col-3">Name:
                </div>
                <input type="text" class="col-4" [(ngModel)]="pipeData.name" #ctrl="ngModel" required>
                <br>
            </div>
            <div class="display-flex">
                <div class="col-3">Description:
                </div>
                <input type="text" class="col-4" [(ngModel)]="pipeData.description">
            </div>
            <div class="display-flex">
                <div class="col-3">Pipe group:
                </div>
                <select name="" id="" [(ngModel)]="pipeData.pipeGroupId" #ctrl2="ngModel" required>
                    <option *ngFor="let pipeGroup of pipeGroupsData | sortByName" [(value)]="pipeGroup.id">{{pipeGroup.name}}</option>
                </select>
            </div>
            <div class="display-flex">
                <div class="col-3">Pipe material group:
                </div>
                <select name="" id="" [(ngModel)]="pipeData.pipeMaterialGroupId" #ctrl3="ngModel" required>
                    <option *ngFor="let pipeMaterial of pipeMaterialGroupsData" [(value)]="pipeMaterial.id">{{pipeMaterial.name}}</option>
                </select>
            </div>
            <div class="display-flex">
                <div class="col-3">Insulation allowed:
                </div>
                <input type="checkbox"  [(ngModel)]="pipeData.insulationAllowed">
            </div>
            <div class="display-flex">
                <div class="col-3">Water filling allowed:
                </div>
                <input type="checkbox"  [(ngModel)]="pipeData.waterFillingAllowed">
            </div>
        </div>
    </div>

    <div>
        <kendo-grid style="border: none" [data]="pipeSizesGridData" (add)="addHandlerForSizeData($event)" (save)="saveHandlerForSizeData($event)"
            (cancel)="cancelHandlerForSizeData($event)" (edit)="editHandlerForSizeData($event)" (remove)="removeHandler($event)">
            <ng-template kendoGridToolbarTemplate>
                <div class="display-flex">
                    <button kendoGridAddCommand [disabled]="!canAddRowToSizeGrid" class="btn add-button light-steel-shadow" style="position: absolute; right: 15px;"
                        type="button" title="add">
                        <i class="fa fa-plus" click></i> Add</button>
                </div>
            </ng-template>
            <kendo-grid-column field="nominalWidth" title="Width [mm]" width="30">
            </kendo-grid-column>
            <kendo-grid-column field="maxSpanWithInsulation" editor="editNumber" title="Max span with insulation [mm]" width="70">
            </kendo-grid-column>
            <kendo-grid-column field="maxSpanWithoutInsulation" editor="editNumber" title="Max span without insulation [mm]" width="70">
            </kendo-grid-column>
            <kendo-grid-column field="insulationThicknessDefault" editor="editNumber" title="Insulation thickness default [mm]" width="70">
            </kendo-grid-column>
            <kendo-grid-column field="outerDiameter" editor="editNumber" title="Outer diameter [mm]" width="60">
            </kendo-grid-column>
            <kendo-grid-column field="nominalDiameter" editor="editNumber" title="Nominal diameter [mm]" width="60">
            </kendo-grid-column>
            <kendo-grid-column field="wallThickness" editor="editNumber" title="Wall thickness [mm]" width="60">
            </kendo-grid-column>
            <kendo-grid-column field="weightPMeter" editor="editNumber" title="Weight per Meter [kg/m]" width="60">
            </kendo-grid-column>
            <kendo-grid-column title="" width="30">
                <ng-template kendoGridCellTemplate>
                    <div class="display-flex">
                        <!--MAGIC DO NOT TOUCH DISABLE FUNCTION-->
                        <button kendoGridEditCommand [disabled]="!canAddRowToSizeGrid" class="attributesBtn" title="Edit">
                            <i class="material-icons">&#xE3C9;</i>
                        </button>
                        <button kendoGridRemoveCommand [disabled]="!canAddRowToSizeGrid" class="attributesBtn btn-remove" data-toggle="modal" data-target="#confirmationModal"
                            title="Remove">
                            <i class="material-icons">&#xE5CD;</i>
                        </button>
                        <button kendoGridSaveCommand class="attributesBtn" title="Save">
                            <i class="material-icons">&#xE876;</i>
                        </button>
                        <button kendoGridCancelCommand class="attributesBtn" title="Cancel">
                            <i class="material-icons">&#xE5C9;</i>
                        </button>
                    </div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="confirmationModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipe Size?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" (click)="removeSize()">Delete</button>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}#tabContent{font-size:11px;border-color:#dddd}.modal-label{width:168px}hr{margin-top:0}#variantsGrid{margin-left:17px;border-color:#dddd}.delete-button{height:23px;width:23px;margin-left:3px;background-color:#d0021b;color:#fff;font-size:12px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;border-radius:2px;cursor:pointer}.configure-button{height:23px;margin-left:3px;background-color:#4a8bb7;color:#fff;font-size:12px;padding:3px 14px;font-weight:300;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;margin-bottom:6px;border-radius:2px;cursor:pointer}.configure-button:disabled{background-color:#999;cursor:default}.step-file{font-size:14px;text-align:center;margin-bottom:10px;font-weight:700}#stpFileDiv{margin-left:auto;margin-right:auto}#variantsTabGrid{border:0;margin-top:26px;border-top:1px solid #ddd}.extra-padding-top{padding-top:10px}.mat-header-cell{font-weight:700}.variantBtn{background-color:#ddd;border:none;padding:6px 18px;outline:0;color:#534f53;cursor:pointer}.variants-header{margin:28px 0 5px;display:flex;justify-content:space-between}.table-label{font-size:16px}.tableCurrentVariant{font-size:14px;border-color:#708090}.borderGray{border-color:#a9a9a9}.borderGray:last-child{border-right:none}.mat-header-row{border-color:#dddd}.highlighted{background-color:#fff!important}.display-flex{display:flex;align-items:center;margin-bottom:10px}.save-button{margin-right:10px}`]
})

export class PipesManagmentComponent implements OnInit {
  public pipeData: any;
  public isPipeNew: boolean = false;
  public stateSubject: Subject<any> = new Subject();
  public pipeSizesGridData: PipeSizeModel[];
  public pipeSizesGridDisplayData: PipeSizeModel[] = [];
  public editedSizeData: PipeSizeModel;
  public canAddRowToSizeGrid = true;
  private sizesOpenedGridRows: number = 0;
  public isSizesGridInChangeMode = false;
  public currentOpenRow: number;
  public formGroup: FormGroup;
  public rowNumber: number;
  private removeData: any;
  public pipeGroupsData: PipeGroupModel[] = [];
  public pipeMaterialGroupsData: PipeMaterialGroupModel[] = [];
  private unitsConverter = new UnitsConverter();

  constructor(private mainPageService: MainPageService, private formBuilder: FormBuilder) { }

  public ngOnInit(): void {
    this.pipeSizesGridData = [];
    this.mainPageService.deletePipeSizeSubject.subscribe((value) => {
      this.pipeSizesGridData = this.pipeSizesGridData.filter(x => x._id !== value);
    });
  }

  loadData(): void {
    this.mainPageService.loadPipeSizes(this.pipeData.id).subscribe((response) => {
      this.pipeSizesGridData = response;
      this.changeDisplayedUnits();
    });
    this.mainPageService.loadAllPipeGroups().subscribe((response) => {
      this.pipeGroupsData = response;
    });
    this.mainPageService.loadAllPipeMaterials().subscribe((response) => {
      this.pipeMaterialGroupsData = response;
    });
  }

  public showManagmentPage(sender, isNew) {
    this.pipeData = sender;
      this.isPipeNew = isNew;
    this.loadData();
  }

  save(): void {
    this.mainPageService.updatePipeInDb(JSON.stringify(this.pipeData)).subscribe(() => { });
    if (this.isPipeNew) {
      this.isPipeNew = false;
    }
  }

  returnHandler() {
    if (this.isPipeNew) {
      this.mainPageService.removePipe(this.pipeData._id).subscribe(() => { });
      this.mainPageService.deletePipeSubject.next(this.pipeData._id);
      this.pipeData = null;
    }
    this.stateSubject.next(this.pipeData);
    this.pipeData = null;
  }

  public editHandlerForSizeData({ sender, rowIndex }) {
    this.canAddRowToSizeGrid = false;

    this.sizesOpenedGridRows++;
    this.isSizesGridInChangeMode = true;
    this.currentOpenRow = rowIndex;
    this.formGroup = this.createFormGroupForSizeData(this.pipeSizesGridData[rowIndex]);
    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandlerForSizeData({ sender, rowIndex }) {
    if (this.isSizesGridInChangeMode) {
      this.sizesOpenedGridRows--;
      sender.closeRow(rowIndex);
      if (this.sizesOpenedGridRows === 0) {
        this.isSizesGridInChangeMode = false;
      }
      this.canAddRowToSizeGrid = true;
    } else {
      this.sizesOpenedGridRows--;
      this.pipeSizesGridData = this.pipeSizesGridData.filter(
        item => item !== this.pipeSizesGridData[rowIndex]
      );
      sender.closeRow(rowIndex);
      this.canAddRowToSizeGrid = true;
    }

  }

  public saveHandlerForSizeData({ sender, formGroup, rowIndex }) {
    this.rowNumber = rowIndex;
    if (this.isSizesGridInChangeMode) {
      if (this.formGroup.valid
      ) {
        this.sizesOpenedGridRows--;

        this.overwriteDataInGrid(rowIndex, formGroup);
        sender.closeRow(rowIndex);
        this.canAddRowToSizeGrid = true;
        if (this.sizesOpenedGridRows === 0) {
          this.isSizesGridInChangeMode = false;
        }
        // this.changeElementUnitsToSI(rowIndex);
        this.editedSizeData = this.pipeSizesGridData[rowIndex];
        this.saveEditedSizes();
      }
    } else {
      if (this.formGroup.valid
      ) {
        this.sizesOpenedGridRows--;


        this.overwriteDataInGrid(rowIndex, formGroup);
        sender.closeRow(rowIndex);
        this.canAddRowToSizeGrid = true;
        if (this.sizesOpenedGridRows === 0) {
          this.isSizesGridInChangeMode = false;
        }
        // this.changeElementUnitsToSI(rowIndex);
        this.editedSizeData = this.pipeSizesGridData[rowIndex];
        this.saveNewSize();
      }
    }
  }

  public addHandlerForSizeData({ sender }) {
    this.sizesOpenedGridRows++;
    this.pipeSizesGridData.push(new PipeSizeModel(null, null, this.pipeData.id));
    this.canAddRowToSizeGrid = false;
    this.currentOpenRow = this.pipeSizesGridData.length - 1;
    sender.editRow(
      this.pipeSizesGridData.length - 1,
      this.formGroup = this.createFormGroupForSizeData(
        this.pipeSizesGridData[this.pipeSizesGridData.length - 1]
      )
    );
  }

  public removeHandler({ dataItem }) {
    this.removeData = dataItem;
  }

  public createFormGroupForSizeData(dataItem: any): FormGroup {
    return this.formBuilder.group({
      _id: dataItem._id,
      id: dataItem.id,
      pipeId: dataItem.pipeId,
      nominalWidth: new FormControl(dataItem.nominalWidth, Validators.compose([Validators.required])),
      code: dataItem.code,
      maxSpanWithInsulation: new FormControl(dataItem.maxSpanWithInsulation, Validators.compose([
        Validators.pattern('^\\d+(?:\\.\\d{1,1})?$')])),
      maxSpanWithoutInsulation: new FormControl(dataItem.maxSpanWithoutInsulation, Validators.compose([
        Validators.pattern('^\\d+(?:\\.\\d{1,1})?$')])),
      insulationThicknessDefault: new FormControl(dataItem.insulationThicknessDefault, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,1})?$')])),
      outerDiameter: new FormControl(dataItem.outerDiameter, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      nominalDiameter: new FormControl(dataItem.nominalDiameter, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,2})?$')])),
      wallThickness: new FormControl(dataItem.wallThickness, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,4})?$')])),
      weightPMeter: new FormControl(dataItem.weightPMeter, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,5})?$')])),
    });
  }

  private changeDisplayedUnits() {
    let tempObject: PipeSizeModel;
    for (let index = 0; index < this.pipeSizesGridData.length; index++) {
      tempObject = {
        _id: this.pipeSizesGridData[index]._id,
        id: this.pipeSizesGridData[index].id,
        pipeId: this.pipeSizesGridData[index].pipeId,
        nominalWidth: this.pipeSizesGridData[index].nominalWidth,
        code: this.pipeSizesGridData[index].code,
        maxSpanWithInsulation: this.unitsConverter.convertFromSIToUnits(
          this.pipeSizesGridData[index].maxSpanWithInsulation, 'mm', 4),
        maxSpanWithoutInsulation: this.unitsConverter.convertFromSIToUnits(
          this.pipeSizesGridData[index].maxSpanWithoutInsulation, 'mm', 4),
        insulationThicknessDefault: this.unitsConverter.convertFromSIToUnits(
          this.pipeSizesGridData[index].insulationThicknessDefault, 'mm', 4),
        outerDiameter: this.unitsConverter.convertFromSIToUnits(
          this.pipeSizesGridData[index].outerDiameter, 'mm', 4),
        nominalDiameter: this.unitsConverter.convertFromSIToUnits(
          this.pipeSizesGridData[index].nominalDiameter, 'mm', 4),
        wallThickness: this.unitsConverter.convertFromSIToUnits(
          this.pipeSizesGridData[index].wallThickness, 'mm', 4),
        weightPMeter: this.pipeSizesGridData[index].weightPMeter
      };
      this.pipeSizesGridDisplayData[index] = Object.assign({}, tempObject);
    }
  }


  overwriteDataInGrid(rowIndex, formGroup) {
    this.pipeSizesGridData[rowIndex].nominalWidth = formGroup.value.nominalWidth;
    this.pipeSizesGridData[rowIndex].maxSpanWithInsulation = formGroup.value.maxSpanWithInsulation;
    this.pipeSizesGridData[rowIndex].maxSpanWithoutInsulation = formGroup.value.maxSpanWithoutInsulation;
    this.pipeSizesGridData[rowIndex].insulationThicknessDefault = formGroup.value.insulationThicknessDefault;
    this.pipeSizesGridData[rowIndex].outerDiameter = formGroup.value.outerDiameter;
    this.pipeSizesGridData[rowIndex].nominalDiameter = formGroup.value.nominalDiameter;
    this.pipeSizesGridData[rowIndex].wallThickness = formGroup.value.wallThickness;
    this.pipeSizesGridData[rowIndex].weightPMeter = formGroup.value.weightPMeter;
  }

  saveNewSize() {
    console.log(this.editedSizeData);
    this.mainPageService.addNewPipeSizeIntoDb(
      JSON.stringify(this.pipeSizesGridData[this.rowNumber])).subscribe((response) => {
        this.editedSizeData._id = response._id;
        this.editedSizeData.id = response.id;
        this.pipeSizesGridData[this.rowNumber] = this.editedSizeData;
      });
  }

  saveEditedSizes() {
    console.log(this.pipeSizesGridData[this.rowNumber]);
    this.mainPageService.updatePipeSizeInDb(JSON.stringify(this.editedSizeData)).subscribe(() => { });
  }

  public removeSize() {
    let index;
    for (let i = 0; i < this.pipeSizesGridData.length; i++) {
      if (this.pipeSizesGridData[i]._id === this.removeData._id) {
        index = i;
      }
    }
    this.deletePipeSize(this.pipeSizesGridData[index]);
  }

  deletePipeSize(size) {
    this.mainPageService.removePipeSize(size._id).subscribe(() => { }, () => { });
    this.mainPageService.deletePipeSizeSubject.next(size._id);
  }
}
